import React, { useEffect, useState } from "react";
import api from "@/lib/api";

const HEARTBEAT_MS = 20000;
const POLL_MS = 20000;
const MAX_AVATARS = 5;

const PresenceIndicator = ({ boardId, currentUserId }) => {
  const [online, setOnline] = useState([]);

  useEffect(() => {
    if (!boardId) return;
    let mounted = true;

    const heartbeat = async () => {
      try { await api.post("/presence/heartbeat", { board_id: boardId }); } catch {}
    };
    const poll = async () => {
      try {
        const r = await api.get(`/boards/${boardId}/presence`);
        if (mounted) setOnline(r.data);
      } catch {}
    };

    heartbeat(); poll();
    const hb = setInterval(heartbeat, HEARTBEAT_MS);
    const pl = setInterval(poll, POLL_MS);
    const onFocus = () => { heartbeat(); poll(); };
    window.addEventListener("focus", onFocus);
    return () => { mounted = false; clearInterval(hb); clearInterval(pl); window.removeEventListener("focus", onFocus); };
  }, [boardId]);

  const others = online.filter((u) => u.user_id !== currentUserId);
  const shown = others.slice(0, MAX_AVATARS);
  const extra = Math.max(0, others.length - MAX_AVATARS);

  if (others.length === 0) return null;

  return (
    <div className="flex items-center gap-1.5" data-testid="presence-indicator" title={`${others.length} collaboratore/i online`}>
      <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse" />
      <span className="text-[10px] uppercase tracking-widest text-emerald-700 font-semibold">Online</span>
      <div className="flex -space-x-2 ml-1">
        {shown.map((u) => (
          <div key={u.user_id} className="relative">
            {u.picture ? (
              <img
                src={u.picture} alt={u.name}
                title={u.name || u.email}
                className="w-7 h-7 rounded-full border-2 border-white object-cover"
              />
            ) : (
              <div
                title={u.name || u.email}
                className="w-7 h-7 rounded-full bg-slate-200 text-slate-700 border-2 border-white flex items-center justify-center text-[10px] font-semibold"
              >
                {(u.name || u.email)[0]?.toUpperCase()}
              </div>
            )}
            <span className="absolute -bottom-0.5 -right-0.5 w-2.5 h-2.5 rounded-full bg-emerald-500 border-2 border-white" />
          </div>
        ))}
        {extra > 0 && (
          <div className="w-7 h-7 rounded-full bg-slate-200 text-slate-700 border-2 border-white flex items-center justify-center text-[9px] font-semibold">
            +{extra}
          </div>
        )}
      </div>
    </div>
  );
};

export default PresenceIndicator;
